import { useLingui } from "@lingui/react/macro";
import { StatusPill } from "@/components/ui/status-pill";
import type { SessionTone } from "@/lib/multi-view";

const PILL = { cooking: "cooking", late: "late", paused: "paused", onDeck: "low" } as const;

/** The status as the board's pill says it; On deck takes the grey of the low-priority pill. */
export function SessionStatusPill({ tone }: { tone: SessionTone }) {
  const { t } = useLingui();
  const label: Record<SessionTone, string> = {
    cooking: t`Cooking`,
    late: t`Late`,
    paused: t`Paused`,
    onDeck: t`On deck`,
  };
  return (
    <StatusPill variant="solid" size="md" status={PILL[tone]}>
      {label[tone]}
    </StatusPill>
  );
}
